<template>
    <div class="max-w-2xl">
        <h1 class="text-3xl font-bold mb-8">Налаштування річної підписки</h1>
        <p class="text-sm text-gray-500 mb-6">
            Лише замовлення з вибраними типами рибалки <b>та</b> тарифами будуть доступні для оплати по підписці.
            Якщо жодного не вибрано — оплата по підписці заблокована повністю.
        </p>

        <form @submit.prevent="store">
            <div class="bg-white rounded-md shadow overflow-hidden mb-6">
                <div class="p-8">
                    <h2 class="text-lg font-semibold mb-4">Дозволені типи рибалки</h2>
                    <div class="grid grid-cols-2 gap-2">
                        <label v-for="type in types" :key="type.id"
                               class="flex items-center gap-2 text-sm cursor-pointer">
                            <input
                                type="checkbox"
                                :value="type.id"
                                v-model="form.allowed_type_ids"
                                class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                            />
                            {{ type.name }}
                        </label>
                    </div>
                    <p v-if="form.errors.allowed_type_ids" class="mt-2 text-sm text-red-600">
                        {{ form.errors.allowed_type_ids }}
                    </p>
                </div>
            </div>

            <div class="bg-white rounded-md shadow overflow-hidden mb-6">
                <div class="p-8">
                    <h2 class="text-lg font-semibold mb-4">Дозволені тарифи</h2>
                    <div class="grid grid-cols-2 gap-2">
                        <label v-for="cat in categories" :key="cat.id"
                               class="flex items-center gap-2 text-sm cursor-pointer">
                            <input
                                type="checkbox"
                                :value="cat.id"
                                v-model="form.allowed_category_ids"
                                class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                            />
                            {{ cat.name }} - {{ cat.lake?.name }}
                        </label>
                    </div>
                    <p v-if="form.errors.allowed_category_ids" class="mt-2 text-sm text-red-600">
                        {{ form.errors.allowed_category_ids }}
                    </p>
                </div>
            </div>

            <div class="bg-white rounded-md shadow overflow-hidden mb-6">
                <div class="p-8">
                    <h2 class="text-lg font-semibold mb-1">Дозволені місця</h2>
                    <p class="text-xs text-gray-400 mb-4">
                        Якщо нічого не вибрано — місця не обмежені (дозволені всі).
                    </p>
                    <div v-for="lake in lakes" :key="lake.id" class="mb-6">
                        <div class="flex items-center gap-3 mb-2">
                            <span class="text-sm font-semibold text-gray-700">{{ lake.name }}</span>
                            <button type="button" class="text-xs text-indigo-500 hover:underline"
                                    @click="toggleLake(lake)">
                                {{ allSelected(lake) ? 'Зняти всі' : 'Вибрати всі' }}
                            </button>
                        </div>
                        <div class="grid grid-cols-2 gap-2 pl-2">
                            <label v-for="point in lake.points" :key="point.id"
                                   class="flex items-center gap-2 text-sm cursor-pointer">
                                <input
                                    type="checkbox"
                                    :value="point.id"
                                    v-model="form.allowed_point_ids"
                                    class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                />
                                {{ point.name }}
                            </label>
                        </div>
                    </div>
                    <p v-if="form.errors.allowed_point_ids" class="mt-2 text-sm text-red-600">
                        {{ form.errors.allowed_point_ids }}
                    </p>
                </div>
            </div>

            <div class="flex justify-end">
                <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                    Зберегти
                </loading-button>
            </div>
        </form>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: { LoadingButton },
    layout: Layout,
    props: {
        config:     Object,
        types:      Array,
        categories: Array,
        lakes:      Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                allowed_type_ids:     this.config?.allowed_type_ids ?? [],
                allowed_category_ids: this.config?.allowed_category_ids ?? [],
                allowed_point_ids:    this.config?.allowed_point_ids ?? [],
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('subscription-config.store'))
        },
        allSelected(lake) {
            console.log('categories', this.categories)
            return lake.points.every(p => this.form.allowed_point_ids.includes(p.id))
        },
        toggleLake(lake) {
            if (this.allSelected(lake)) {
                this.form.allowed_point_ids = this.form.allowed_point_ids.filter(
                    id => !lake.points.some(p => p.id === id)
                )
            } else {
                const toAdd = lake.points.map(p => p.id).filter(
                    id => !this.form.allowed_point_ids.includes(id)
                )
                this.form.allowed_point_ids = [...this.form.allowed_point_ids, ...toAdd]
            }
        },
    },
}
</script>
